import React from 'react';

function NotFoundPage() {
  return <div>Not Found Page</div>;
}

export default NotFoundPage;
